import React from 'react'
import { css, cx } from '@emotion/css'
import { legacyTheme } from '../legacy-theme'

export function LegacyEmptyState({ children }) {
  return (
    <div
      data-e2e="legacy-empty-state"
      className={cx(
        'legacy-empty-state',
        'empty-row',
        'no-padding',
        css`
          border-top: 1px solid ${legacyTheme.colors.grayLighterMiddle};
          background-image: linear-gradient(#f7f7f7, #fff);
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 50px;
          line-height: 50px;
          color: ${legacyTheme.colors.grayMiddle};
        `
      )}
    >
      {children}
    </div>
  )
}
